import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  const pagePath = location.pathname + location.search;

  useEffect(() => {
    trackPageView(pagePath);
  }, [pagePath]);

  return null;
};

export default AnalyticsTracker;
